import { render, staticRenderFns } from "./online_training.vue?vue&type=template&id=2b617445&scoped=true"
import script from "./online_training.vue?vue&type=script&lang=js"
export * from "./online_training.vue?vue&type=script&lang=js"
import style0 from "./online_training.vue?vue&type=style&index=0&id=2b617445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b617445",
  null
  
)

export default component.exports